import { render, staticRenderFns } from "./TransactionToTransferModal.vue?vue&type=template&id=54f9a353&scoped=true&"
import script from "./TransactionToTransferModal.vue?vue&type=script&lang=js&"
export * from "./TransactionToTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./TransactionToTransferModal.vue?vue&type=style&index=0&id=54f9a353&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9a353",
  null
  
)

export default component.exports